'use strict'

class Publication {
    constructor(){
		var self=this;
		$('section.publication .slider').bxSlider({
            mode: 'fade',
            pager: false,
            controls: true
        });
		
		if($('#player').length==1){
			setTimeout(function(){
				self.player = new YT.Player('player', {
					height: '100%',
					width: '100%',
					videoId: $('#player').data('video'),
					events: {
						'onReady': self.YTPlayerReady,
						'onStateChange': self.YTStateChange
					}
				});
			}, 1000);
		};
    }
	
	YTPlayerReady(event) {
		var self=this;
		
		event.target.playVideo();
		event.target.mute(); // comment out if you don't want the auto played video muted
		event.target.seekTo(0);
		
		const currentVideo=event.target;
		const videoTime=currentVideo.getDuration()-2;
		const videoInterval=setInterval(function(){
			if(videoTime<currentVideo.getCurrentTime()){
				clearInterval(videoInterval);
				event.target.seekTo(0);
				event.target.playVideo();
				event.target.mute(); // comment out if you don't want the auto played video muted
			}
		}, 500);
	}

	YTStateChange(event) {
		switch(event.data) {
			case -1:
				//fullScreen();
				var player = event.target;
				player.playVideo();//won't work on mobile
				var iframe = $('#player')[0];
				var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullScreen;
				if (requestFullScreen) {
					requestFullScreen.bind(iframe)();
				}
			break;
		}
	}

}

export default Publication;